<template>
    <div v-if="currentCna">
        <b-row>
            <b-col cols="3">
                <BaseTextOutput label="First Name" :value="currentCna.firstName"/>
            </b-col>
            <b-col cols="3">
                <BaseTextOutput label="Last Name" :value="currentCna.lastName"/>
            </b-col>
            <b-col cols="3">
                <BaseTextOutput label="SSN" :value="currentCna.ssn4"/>
            </b-col>
        </b-row>
        <div v-if="currentCna.priorNames.length>0">
          <b-row>
            <b-col cols="12">
              Formerly known as:
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <ol>
                <li v-for="(priorName, index) in currentCna.priorNames" :key="index">
                  {{priorName.firstName+' '+priorName.lastName}}
                </li>
              </ol>
            </b-col>
          </b-row>
        </div>
        <b-row>
            <b-col>
                <BaseRadioInput v-model="verify"
                                :v="$v.verify"
                                label="Has this CNA worked at your facility?"
                                tip="If information provided is inaccurate you will be able to correct it here."
                                slug="verify"
                                :options="opts.yesNoBoolOptions"
                                @input="handleVerify"
                />
            </b-col>
        </b-row>
            <b-row v-if="verify!=null">
                <b-col>
                    <BaseSelector v-model="currentCna.status"
                                  label="Status"
                                  :options="verify?statusOptions.filter(x=>x.value!=='NWH'):statusOptions.filter(x=>x.value==='NWH')"
                                  slug="status"
                                  :v="$v.currentCna.status"
                                  setId="cnaStatusSelector"
                                  @input="handleStatus"
                                  :plaintext="!verify"
                    />
                </b-col>
            </b-row>
        <b-row v-if="currentCna.status==='NWH'">
            <b-col>
                <p>By selecting Never Worked Here, the nurse aide’s self-reported work history will be deleted from the registry and their status may become Inactive. MDH has found the primary reason a name is not recognized by a provider is the Nurse Aide has not updated their name in the registry. If this is the case, please communicate with the nurse aide to update their name to avoid deleting the work history and changing the individual’s status to Inactive.</p>
                <p>If you have verified in your records the individual was not employed by your facility since the prior semi-annual submission to MDH, select Confirm. The individual’s work history will be deleted and their status may become Inactive.</p>
            </b-col>
        </b-row>
        <div v-if="verify">
            <b-row v-if="currentCna.status==='OTH'">
                <b-col>
                    <BaseTextInput v-model="currentCna.otherStatus"
                                   :v="$v.currentCna.otherStatus"
                                   slug="otherStatus"
                                   label="Other status:"/>
                </b-col>
            </b-row>
            <b-row class="align-bottom" v-if="currentCna.status==='ONC' || currentCna.status==='LOA' || currentCna.status==='OTH' || currentCna.status==='TER'">
                <b-col cols="8">
                    <BaseDateOfBirthInput v-model="currentCna.lastWorkedDate"
                                   :v="$v.currentCna.lastWorkedDate"
                                   slug="lastWorkedDate"
                                   :label="currentCna.status==='OTH'?'Last Worked Date as a Nurse Aide':'Last Worked Date'"
                                   :messages="endDateMessages"
                                   tip="Format: MM/DD/YYYY"
                    />
                </b-col>
                <b-col cols="4">
                    <b-button variant="secondary" class="m-2" @click="clearDate">Clear date</b-button>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col cols="0">
                <b-button variant="primary" class="m-2" @click="submit">Submit</b-button>
            </b-col>
            <b-col>
                <b-button variant="secondary" class="m-2" @click="hideVerifyModal">Cancel</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import {required, requiredIf} from 'vuelidate/lib/validators'
    import maxDate from "@/validators/maxDate";
    import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput";
    import axios from 'axios';
    import BaseRadioInput from "@/components/templates/input/BaseRadioInput";
    import {commonOptions} from "@/mixins/commonOptions";


    export default {
        name: "ProviderCNAStatusUpdate",
        data(){
            return{
                verify: null,
                endDateMessages: {
                    minDate: 'End Date must be after Start Date.',
                    maxDate: 'End Date can not be in the future.'
                },
                statusTemp: null,
            }
        },
        components: {
            BaseTextOutput,
            BaseSelector,
            BaseDateOfBirthInput,
            BaseTextInput,
            BaseRadioInput
        },
        mixins: [
            commonOptions
        ],
        props:{
            currentCna: Object,
            statusOptions: Array
        },
        methods: {
            forceRefresh(){ //validator breaks when switching to current or never worked here
                let temp = this.$v.currentCna.$model;
                this.$v.currentCna.$model=null;
                this.$v.currentCna.$model=temp;
                this.$v.$reset();
            },
            hideVerifyModal(){
                this.$emit('hideVerifyModal');
                this.verify=null;
            },
            submit(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }
                let verifiedCNA = Object.assign({}, this.currentCna);
                delete verifiedCNA.certificateStatus;
                axios.put(`${process.env.VUE_APP_API_BASE_URL}/provider/cna/${this.verify?'verify':'reject'}`,verifiedCNA)
                    .then(response=>{
                        this.$emit('success',this.verify);
                    })
                    .catch(error=>{
                        this.$emit('failure');
                    })
                    .finally(()=>{
                        this.$emit('hideVerifyModal');
                    })
            },
            clearDate(){
                this.currentCna.lastWorkedDate = null;
                this.forceRefresh();
            },
            handleVerify(){
                if(this.statusTemp==null){
                    this.statusTemp = this.currentCna.status;

                }
                console.log('start: '+this.statusTemp);
                if(this.verify){
                    this.currentCna.status=this.statusTemp;
                    console.log('yes: '+this.statusTemp);
                }
                else{
                    this.statusTemp=this.currentCna.status;
                    this.$nextTick(()=>{
                        console.log('no: '+this.statusTemp);
                        this.currentCna.status='NWH';
                    });
                }
                console.log('end: '+this.statusTemp);
                this.forceRefresh();
            },
            handleStatus(){
                if(this.currentCna.status!=='NWH'){
                    this.statusTemp=this.currentCna.status;
                }
                this.forceRefresh()
            }
        },


        validations:{
            verify: {required},
            currentCna:
                {
                    required,
                    firstName: {required: false},
                    lastName: {required: false},
                    ssn4: {required: false},
                    status: {
                        required: requiredIf(function(){
                            return this.verify;
                         }
                        )
                    },
                    otherStatus: {
                        required : requiredIf(function(){
                                return this.verify && this.currentCna.status==='OTH';
                            }
                        )
                    },
                    lastWorkedDate: {
                        required: requiredIf(function(){
                                return this.verify &&  (this.currentCna.status==='ONC' || this.currentCna.status==='LOA' || this.currentCna.status==='TER' || this.currentCna.status==='OTH');
                            }
                        ),
                        maxDate: maxDate(new Date()),
                    },
                }
        }
    }
</script>

<style scoped>

</style>